// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".poNoClass[data-v-6dcb9384] .el-input.is-disabled .el-input__inner {\n  color: red !important;\n}\n.red-border[data-v-6dcb9384] .el-input__inner,\n.red-border[data-v-6dcb9384] .el-textarea__inner,\n.red-border[data-v-6dcb9384] .cargo-rich-textarea {\n  border: 1px solid red !important;\n}\n", ""]);
// Exports
module.exports = exports;
